import { safeGlobalProp } from './safe_globals.js';

/**
 * Returns `window` if running in a browser, otherwise `undefined`.
 */
function getSafeLocalStorage() {
    if (typeof window === 'undefined')
        return undefined;
    try {
        return window.localStorage;
    }
    catch {
        return undefined; // e.g. Safari private-mode block
    }
}
/**
 * Call a Storage method by name, silencing any errors or missing storage.
 *
 * @param method  One of the keys of the Storage interface: "getItem", "setItem", etc.
 * @param args    The arguments you’d normally pass to that method.
 * @returns       The method’s return value, or undefined if storage/method isn’t available.
 */
function callStorage(method, ...args) {
    const storage = getSafeLocalStorage();
    if (!storage)
        return undefined;
    const fn = storage[method];
    if (typeof fn !== 'function')
        return undefined;
    try {
        return fn.apply(storage, args);
    }
    catch {
        return undefined;
    }
}
/**
 * Safely call storage methods (`localStorage` or `sessionStorage`) without blowing up.
 * Returns `undefined` on any error.
 */
function safeStorage(storageName, method, ...args) {
    try {
        const store = safeGlobalProp(storageName);
        if (!store || typeof store[method] !== "function")
            return undefined;
        return store[method](...args);
    }
    catch {
        return undefined;
    }
}

export { callStorage, getSafeLocalStorage, safeStorage };
//# sourceMappingURL=safe_storage.js.map
